export const checkIsStoreNew = ({ date }) => {
  let createdAt = new Date(date);

  let versionChangeDate = new Date('2021-09-29'); // replace with your second date

  if (createdAt > versionChangeDate) {
    return true;
  } else if (createdAt < versionChangeDate) {
    return false;
  }
};

export const checkIsStoreBOGONew = ({ date }) => {
  let createdAt = new Date(date);

  let versionChangeDate = new Date('2025-08-23'); // replace with your second date

  if (createdAt > versionChangeDate) {
    return true;
  } else if (createdAt < versionChangeDate) {
    return false;
  }
};

export const checkIsStoreDashboardNew = ({ date }) => {
  let createdAt = new Date(date);

  let versionChangeDate = new Date('2021-02-09'); // replace with your second date

  if (createdAt > versionChangeDate) {
    return true;
  } else if (createdAt < versionChangeDate) {
    return false;
  }
};

// Forced on for every shop while V3 is sunset.
// `shopInfo` is accepted for signature parity with callers; no longer read.
// eslint-disable-next-line no-unused-vars
export const checkIsStoreForV4 = (shopInfo) => true;

// Only show the "Get your first sale" 3-step onboarding to shops installed
// on/after 2026-05-29 — the day we rolled the new onboarding out. Older
// shops have already been through the app, so the bulky checklist just gets
// in their way. Reads both camelCase and snake_case for resilience, and
// stays hidden when the install date is missing (safer to under-show the
// onboarding than to flash it at someone who shouldn't see it).
export const shouldShowOnboarding = (shopInfo) => {
  const data = shopInfo?.data || {};
  const installedAt = data.createdAt || data.created_at;
  if (!installedAt) return false;
  const parsed = new Date(installedAt);
  if (Number.isNaN(parsed.getTime())) return false;
  const cutoff = new Date('2026-05-29T00:00:00Z');
  return parsed >= cutoff;
};
